export const TEXT_FIELD_TEST_IDS = {
    WITH_LABEL: 'text-field-with-label',
    MENU_DROPDOWN: 'text-field-menu-dropdown',
    CURRENCY: 'text-field-currency',
};
